import { useEffect, useState } from "react";
import GameBody from "../components/GameBody";
import WorldCupBar from "../components/WorldCupBar";
import { useNavigate, useParams } from "react-router-dom";
import Card from "../components/Card";
import Ideal from "../components/Ideal";
import Result from "../components/Result";
import Progress from "../components/Progress";

const gameData = [
  { id: 0, name: "마동석", image: "/worldcup/imgs/man/마동석.webp" },
  { id: 1, name: "손석구", image: "/worldcup/imgs/man/손석구.webp" },
  { id: 2, name: "폴블랑코", image: "/worldcup/imgs/man/폴블랑코.webp" },
  { id: 3, name: "뷔(BTS)", image: "/worldcup/imgs/man/뷔.webp" },
  { id: 4, name: "릴러말즈", image: "/worldcup/imgs/man/릴러말즈.webp" },
  { id: 5, name: "정국(BTS)", image: "/worldcup/imgs/man/정국.webp" },
  { id: 6, name: "송중기", image: "/worldcup/imgs/man/송중기.webp" },
  { id: 7, name: "이도현", image: "/worldcup/imgs/man/이도현.webp" },
  { id: 8, name: "박성훈", image: "/worldcup/imgs/man/박성훈.webp" },
  { id: 9, name: "박해진", image: "/worldcup/imgs/man/박해진.webp" },
  { id: 10, name: "이정재", image: "/worldcup/imgs/man/이정재.webp" },
  { id: 11, name: "유해진", image: "/worldcup/imgs/man/유해진.webp" },
  { id: 12, name: "박성웅", image: "/worldcup/imgs/man/박성웅.webp" },
  { id: 13, name: "유연석", image: "/worldcup/imgs/man/유연석.webp" },
  { id: 14, name: "기안84", image: "/worldcup/imgs/man/기안.webp" },
  { id: 15, name: "손흥민", image: "/worldcup/imgs/man/손흥민.webp" },
  { id: 16, name: "조규성", image: "/worldcup/imgs/man/조규성.webp" },
  { id: 17, name: "강하늘", image: "/worldcup/imgs/man/강하늘.webp" },
  { id: 18, name: "권상우", image: "/worldcup/imgs/man/권상우.webp" },
  { id: 19, name: "이제훈", image: "/worldcup/imgs/man/이제훈.webp" },
  { id: 20, name: "조진웅", image: "/worldcup/imgs/man/조진웅.webp" },
  { id: 21, name: "임시완", image: "/worldcup/imgs/man/임시완.webp" },
  { id: 22, name: "승관(세븐틴)", image: "/worldcup/imgs/man/승관.webp" },
  { id: 23, name: "민규(세븐틴)", image: "/worldcup/imgs/man/민규.webp" },
  { id: 24, name: "태용(엔시티)", image: "/worldcup/imgs/man/태용.webp" },
  { id: 25, name: "텐(엔시티)", image: "/worldcup/imgs/man/텐.webp" },
  { id: 26, name: "마크툽", image: "/worldcup/imgs/man/마크툽.webp" },
  { id: 27, name: "덱스", image: "/worldcup/imgs/man/덱스.webp" },
  { id: 28, name: "신용재", image: "/worldcup/imgs/man/신용재.webp" },
  { id: 29, name: "정우성", image: "/worldcup/imgs/man/정우성.webp" },
  { id: 30, name: "박해수", image: "/worldcup/imgs/man/박해수.webp" },
  { id: 31, name: "김우빈", image: "/worldcup/imgs/man/김우빈.webp" },
];

export default function Woman() {
  const TOTAL_ROUND = 31;
  const navigator = useNavigate();
  const [result, setResult] = useState(false);
  const [completedRound, setCompletedRound] = useState(0);
  const [progressRound, setProgressRound] = useState(null);
  const [selectedCards, setSelectedCards] = useState([]);
  const [remainingCards, setRemainingCards] = useState(gameData);

  const [game16, setGame16] = useState([]);
  const [game8, setGame8] = useState([]);
  const [game4, setGame4] = useState([]);
  const [game2, setGame2] = useState([]);

  const [last, setLast] = useState(null);

  const initializeGame = () => {
    const shuffled = remainingCards.sort(() => 0.5 - Math.random());

    const selected = shuffled.slice(0, 2);
    setSelectedCards(selected);
  };
  const startGame = (list, result) => {
    const remaining = remainingCards.slice(2);

    if (game16.length < 16) {
      setGame16((prev) => [...prev, list]);
    } else if (game8.length < 8 && game16.length >= 16) {
      setGame8((prev) => [...prev, list]);
    } else if (game8.length >= 8 && game4.length < 4) {
      setGame4((prev) => [...prev, list]);
    } else if (game4.length >= 4 && game2.length < 2) {
      setGame2((prev) => [...prev, list]);
    } else {
      setLast(list);
    }

    setRemainingCards(remaining);
    setCompletedRound((prev) => prev + 1);
    if (result) {
      setResult(true);
    }
  };

  useEffect(() => {
    initializeGame();
    gameData.forEach(({ image }) => {
      const img = new Image();
      img.src = image;
    });
  }, []);
  useEffect(() => {
    if (game16.length === 16 && game8.length === 0) {
      setRemainingCards(game16);
    } else if (game8.length === 8 && game4.length === 0) {
      setRemainingCards(game8);
    } else if (game4.length === 4 && game2.length === 0) {
      setRemainingCards(game4);
    } else if (game2.length === 2 && last === null) {
      setRemainingCards(game2);
    }
    setSelectedCards(remainingCards.slice(0, 2));
    const progressRound = (completedRound / TOTAL_ROUND) * 100;
    setProgressRound(progressRound.toFixed(0));
    if (result) {
      const url = new URLSearchParams();
      url.append("image", last.image);
      url.append("name", last.name);
      const query = url.toString();
      navigator(`/result?${query}`);
    }
  }, [remainingCards]);

  const round = () => {
    if (game16.length < 16) return "32강";
    if (game8.length < 8) return "16강";
    if (game4.length < 4) return "8강";
    if (game2.length < 2) return "4강";
    return "결승";
  };

  return (
    <>
      <WorldCupBar round={round()} currendRound={completedRound + 1} />
      <GameBody
        gameData={selectedCards}
        startGame={startGame}
        result={completedRound === 30 && true}
      />
      <Progress progressRound={progressRound} />
    </>
  );
}
